import PlatformExpertsListComponent from './PlatformExpertsList.component'

export default PlatformExpertsListComponent